import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';
import menuService from '../services/menuService';

const ProtectedRoute = ({ children, userType, requiredPermission, requiresAuth = true }) => {
    const location = useLocation();
    const currentUser = authService.getCurrentUser();
    const currentUserType = authService.getUserType();
    const token = localStorage.getItem('token');



    // Check if authentication is required and user is authenticated
    if (requiresAuth && (!currentUser || !token)) {
        // Redirect to login page with the return url
        return <Navigate to="/login" state={{ from: location.pathname }} />;
    }

    // If user type is specified, check if current user matches
    if (userType && currentUserType !== userType) {
        // If user is logged in but accessing wrong area, redirect to their dashboard
        const dashboardPaths = {
            employee: '/employee/dashboard',
            franchise: '/franchise/dashboard',
            customer: '/customer/dashboard'
        };
        return <Navigate to={dashboardPaths[currentUserType] || '/login'} />;
    }

    // Check specific permission if required
    if (requiredPermission) {
        if (!authService.hasPermission(requiredPermission)) {
            console.error('Access denied - Missing permission:', requiredPermission);
            return <Navigate to="/unauthorized" />;
        }
    }

    // For dynamic permission checking based on current path
    if (currentUser && currentUserType) {
        const userPermissions = currentUser.role?.permissions || [];
        
        // Check if user has access to current path using menu service
        if (!menuService.hasAccessToPath(location.pathname, currentUserType, userPermissions)) {
            console.error('Access denied - No path access:', location.pathname);
            return <Navigate to="/unauthorized" />;
        }
    }

    return children;
};

export default ProtectedRoute; 